import { render, staticRenderFns } from "./GatewayOverviewCard.vue?vue&type=template&id=370b1ca0&scoped=true"
import script from "./GatewayOverviewCard.vue?vue&type=script&lang=ts"
export * from "./GatewayOverviewCard.vue?vue&type=script&lang=ts"
import style0 from "./GatewayOverviewCard.vue?vue&type=style&index=0&id=370b1ca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b1ca0",
  null
  
)

export default component.exports